import { FCX } from "@datassential/platform-ui-lib";
import TextInput from "@components/TextInput";
import { FiSearch } from "react-icons/fi";
import { useHomeContext } from "@pages/Home/HomeContext";

const HomeSubHeader: FCX = ({
    children,
}) => {
    const { search, setSearch } = useHomeContext();

    return (
        <div className="HomeSubHeader">
            <TextInput
                className="HomeSubHeader__search"
                placeholder="Search an item"
                testId="blockSearchHeaderInput"
                prefix={<FiSearch/>}
                value={search}
                setValue={setSearch}
            />
            {children}
        </div>
    );
};

export default HomeSubHeader;
